export const tableHeaderProps = {
    align: "center",
    color: "text.subheader",
    variant: "h6",
    fontSize: "14px",
    fontWeight: "bold",
};
